import MessagingPrivacyPolicyPage from '../../../src/client/pages/messaging-privacy-policy';

export default MessagingPrivacyPolicyPage;
